import { useContext } from "react"
import PropTypes from "prop-types"
import { Paper } from "@mui/material"
import useGraphContext from "./context/graph"
import performanceTemplate from "./templates/performance"
import { MODEL_METADATA_SHAPE } from "connected-components/asset-view/prop-types"
import { INSTRUMENTS_WITH_METADATA_SHAPE } from "connected-components/asset-view/prop-types"

const TEMPLATES = {
  performance: performanceTemplate,
}

export default function GraphWrapper(props) {
  const { context: parentContext } = props
  const [GraphContext, contextValue] = useGraphContext(parentContext)

  return (
    <GraphContext.Provider value={contextValue}>
      <Graph
        {...{
          ...props,
          context: GraphContext,
        }}
      />

    </GraphContext.Provider>
  )
}

GraphWrapper.propTypes = {
  modelMetadata: MODEL_METADATA_SHAPE.isRequired,
  context: PropTypes.object.isRequired,
  instrumentsWithMetadata: INSTRUMENTS_WITH_METADATA_SHAPE.isRequired,
}

function Graph(props) {
  const { context, instrumentsWithMetadata, modelMetadata } = props
  const { selectedTemplate } = useContext(context)

  const template = TEMPLATES[selectedTemplate] || TEMPLATES.performance

  const content = <div className="graph-wrapper">
    <Paper square className="graph-header" elevation={0}>
      <template.Header context={context} modelMetadata={modelMetadata} />
    </Paper>
    <template.Component
      context={context}
      instrumentsWithMetadata={instrumentsWithMetadata}
      modelMetadata={modelMetadata}
    />
  </div>

  if (template.Context) {
    return <template.Context>
      {content}
    </template.Context>
  }

  return content
}

Graph.propTypes = {
  modelMetadata: MODEL_METADATA_SHAPE.isRequired,
  context: PropTypes.object.isRequired,
  instrumentsWithMetadata: INSTRUMENTS_WITH_METADATA_SHAPE.isRequired,
}
